import { EExpenseType } from '../enums/expenses/EExpenseType';
import { EHolidayType } from '../enums/holiday/EHoliday';
import { EProjectStatus } from '../enums/projects/EProjectStatus';
import { ERefundStatus } from '../enums/refund/ERefundStatus';
import { EEmployeeContract } from '../enums/user/EContract';
import { ERole } from '../enums/user/ERole';
import { ETheme } from '../enums/user/ETheme';
import { EWorkmode } from '../enums/user/EWorkmode';
import {
  ELeaveDaysStatus,
  ELeaveDaysType,
} from '../enums/leave-days/ELeaveDays';
import { darkPalette, lightPalette } from '../mui/palettes';

export const getProjectStatusColor = (status: EProjectStatus) => {
  if (status === EProjectStatus.CANCELED) {
    return 'error';
  }
  if (status === EProjectStatus.COMPLETED) {
    return 'success';
  }
  return 'warning';
};

export const getRefundStatusColor = (status: ERefundStatus) => {
  if (status === ERefundStatus.PENDING) {
    return 'warning';
  }
  if (status === ERefundStatus.ACCEPTED) {
    return 'success';
  }
  return 'error';
};
export const getHolidayTypeColor = (status: EHolidayType) => {
  if (status === EHolidayType.NATIONAL) {
    return {
      background: 'rgba(33,150,243,0.2)',
      primary: '#2196F3',
    };
  }
  if (status === EHolidayType.RELIGIOUS) {
    return {
      background: 'rgba(244,91,105,0.2)',
      primary: '#F45B69',
    };
  }
  return {
    background: 'rgba(141,110,99,0.2)',
    primary: '#8D6E63',
  };
};

export const getWorkModeColor = (workMode: EWorkmode) => {
  if (workMode === EWorkmode.ONSITE) {
    return 'success';
  }
  if (workMode === EWorkmode.HYBRID) {
    return 'warning';
  }
  return 'primary';
};

export const getVacationStatusColor = (vacationStatus: ELeaveDaysStatus) => {
  if (
    [ELeaveDaysStatus.ACCEPTED, ELeaveDaysStatus.COMPLETED].includes(
      vacationStatus,
    )
  ) {
    return 'success';
  }
  if (vacationStatus === ELeaveDaysStatus.REJECTED) {
    return 'error';
  }
  return 'warning';
};

export const getLeaveDayTypeColor = (leaveDayType: ELeaveDaysType) => {
  if (leaveDayType === ELeaveDaysType.BUSINESS_TRAVEL_LEAVE) {
    return 'primary';
  }
  if (leaveDayType === ELeaveDaysType.CARRY_OVER_LEAVE) {
    return 'error';
  }
  if (leaveDayType === ELeaveDaysType.SICK_LEAVE) {
    return 'warning';
  }
  if (leaveDayType === ELeaveDaysType.VACATION_LEAVE) {
    return 'success';
  }
};

export const getEmployeeContractColor = (
  employeeContract: EEmployeeContract,
) => {
  if (employeeContract === EEmployeeContract.PERMANENT) {
    return 'primary';
  }
  return 'warning';
};

export const getEmployeeRoleColor = (role: ERole) => {
  if (role === ERole.USER) {
    return 'primary';
  }
  return 'success';
};

export const getEmployeeIsVerifiedColor = (isVerified: boolean) => {
  if (isVerified) {
    return 'success';
  }
  return 'error';
};

export const getExpenseTypeColor = (status: EExpenseType, theme?: ETheme) => {
  const correctPalette = theme === ETheme.LIGHT ? lightPalette : darkPalette;
  const statusColors = {
    [EExpenseType.INCREMENT]: {
      background: correctPalette?.expense?.paper.background,
      primary: correctPalette?.expense?.paper.primary,
    },
    [EExpenseType.WATER]: {
      background: correctPalette?.expense?.water.background,
      primary: correctPalette?.expense?.water.primary,
    },
    [EExpenseType.PAPER]: {
      background: correctPalette?.expense?.paper.background,
      primary: correctPalette?.expense?.paper.primary,
    },
    [EExpenseType.COFFEE]: {
      background: correctPalette?.expense?.coffee.background,
      primary: correctPalette?.expense?.coffee.primary,
    },
    [EExpenseType.CHEMISTRY]: {
      background: correctPalette?.expense?.chemistry.background,
      primary: correctPalette?.expense?.chemistry.primary,
    },
    [EExpenseType.OTHER_EQUIPMENT]: {
      background: correctPalette?.expense?.other_equipment.background,
      primary: correctPalette?.expense?.other_equipment.primary,
    },
    [EExpenseType.FRESHENERS]: {
      background: correctPalette?.expense?.fresheners.background,
      primary: correctPalette?.expense?.fresheners.primary,
    },
    [EExpenseType.GARBAGE_BAGS]: {
      background: correctPalette?.expense?.garbage_bags.background,
      primary: correctPalette?.expense?.garbage_bags.primary,
    },
    [EExpenseType.SOAP]: {
      background: correctPalette?.expense?.soap.background,
      primary: correctPalette?.expense?.soap.primary,
    },
    [EExpenseType.BATTERIES]: {
      background: correctPalette?.expense?.batteries.background,
      primary: correctPalette?.expense?.batteries.primary,
    },
    [EExpenseType.JUICES_CANDIES]: {
      background: correctPalette?.expense?.juices_candies.background,
      primary: correctPalette?.expense?.juices_candies.primary,
    },
    [EExpenseType.COMPUTER_EQUIPMENT]: {
      background: correctPalette?.expense?.computer_equipment.background,
      primary: correctPalette?.expense?.computer_equipment.primary,
    },
  };
  return statusColors[status];
};
